import { mkQcsSyncResourceStore } from 'data/qcsSyncResourceTypes';
import { handleActions } from 'redux-actions';
import { upsertResources, completeWithError } from 'data/qcsSyncResourceReducerHelpers';

import { INVESTMENT_SYMBOLS_KEY as KEY} from './investmentSymbolsTypes';
import * as actions from './investmentSymbolsActions';

const investmentSymbolsReducer = handleActions({

  [actions.getInvestmentSymbols]:
    (state) => state.merge({ isLoading: true }),
  [actions.getInvestmentSymbolsSuccess]:
    (state, action) => upsertResources(state, action.payload),
  [actions.getInvestmentSymbolsFailure]:
    (state, { payload: error }) => completeWithError(state, error),

}, mkQcsSyncResourceStore());

export const INVESTMENT_SYMBOLS_KEY = KEY;
export default investmentSymbolsReducer;
